// Links between the Revenue page and the Audiences workspace it opens.
// Audiences reads them from the address bar, so a block or list carries over
// a reload and can be bookmarked.

export const REVENUE_PATH = '/revenue';
export const REVENUE_AUDIENCES_PATH = '/revenue/audiences';

// Opportunities stays PickleCourts staff only until it is released to venues.
// The server enforces the same rule (REVENUE_OPPORTUNITIES_VENUE_ACCESS);
// change both together.
export function canSeeOpportunities(isSuperAdmin: boolean): boolean {
  return isSuperAdmin;
}

export function revenueHomePath(isSuperAdmin: boolean): string {
  return canSeeOpportunities(isSuperAdmin) ? REVENUE_PATH : REVENUE_AUDIENCES_PATH;
}

export interface AudiencesLink {
  listId: string | null;
  prompt: string | null;
  // Ask the prompt straight away, for a question typed on the Revenue page.
  send: boolean;
  block: string | null;
  riskCents: number | null;
}

/** Open Audiences to build a list for one weak block. */
export function audiencesLinkForBlock({ blockLabel, prompt, revenueAtRiskCents }: {
  blockLabel: string;
  prompt: string;
  revenueAtRiskCents: number;
}): string {
  const params = new URLSearchParams({
    block: blockLabel,
    prompt,
    risk: String(Math.round(revenueAtRiskCents)),
  });
  return `${REVENUE_AUDIENCES_PATH}?${params.toString()}`;
}

/** Open Audiences and ask a question someone typed on the Revenue page. */
export function audiencesLinkForQuestion(question: string): string {
  return `${REVENUE_AUDIENCES_PATH}?${new URLSearchParams({ prompt: question.trim(), send: '1' }).toString()}`;
}

/** Open Audiences on one saved list. */
export function audiencesLinkForList(listId: string): string {
  return `${REVENUE_AUDIENCES_PATH}?${new URLSearchParams({ list: listId }).toString()}`;
}

export function readAudiencesLink(search: string): AudiencesLink {
  const params = new URLSearchParams(search);
  const text = (key: string) => {
    const value = params.get(key)?.trim();
    return value ? value.slice(0, 300) : null;
  };
  const risk = Number(params.get('risk'));
  return {
    listId: text('list'),
    prompt: text('prompt'),
    send: params.get('send') === '1',
    block: text('block'),
    riskCents: Number.isFinite(risk) && risk > 0 ? risk : null,
  };
}
